import AddButton from "components/ui/Button/AddButton/AddButton";
import Heading from "components/ui/Heading/Heading";
import PaginationSearch from "components/ui/InputTypes/InputSearch/PaginationSearch/PaginationSearch";
import { REMINDERS_TABLE_ACTIONS } from "../enums";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { REMINDER_CREATE_PERMISSION } from "components/dashboard/ServiceModule/permissions";
import "./RemindersHeader.scss";

const RemindersHeader = ({ hasData, handleActionModal }) => {
    return (
        <div className='reminders-header'>
            <div
                className={`reminders-header__withdata ${
                    !hasData ? "reminders-header__underule" : ""
                }`}>
                <div>
                    <Heading headingText={"Reminders"} />
                </div>
                {!hasData && (
                    <div>
                        <ComponentAccessControl
                            baseResources={REMINDER_CREATE_PERMISSION}>
                            <AddButton
                                btnText={"Create reminder"}
                                onClick={() =>
                                    handleActionModal(
                                        REMINDERS_TABLE_ACTIONS.CREATE_REMINDER
                                    )
                                }
                            />
                        </ComponentAccessControl>
                    </div>
                )}
            </div>

            {hasData && (
                <div className='reminders-header__empty'>
                    <div>
                        <PaginationSearch
                            placeholder={"Search reminders here"}
                        />
                    </div>
                    <div>
                        <ComponentAccessControl
                            baseResources={REMINDER_CREATE_PERMISSION}>
                            <AddButton
                                btnText={"Create reminder"}
                                onClick={() =>
                                    handleActionModal(
                                        REMINDERS_TABLE_ACTIONS.CREATE_REMINDER
                                    )
                                }
                            />
                        </ComponentAccessControl>
                    </div>
                </div>
            )}
        </div>
    );
};
export default RemindersHeader;
